<template>
  <section class="register-section">
    <div class="register-banner-wrapper gradiant-banner">
      <b-container>
        <b-row>
          <b-col cols="12" md="6" class="left">
            <div class="title">Signup for free</div>
            <p class="tagline">Start creating the future now</p>
            <p class="details">
              online courses from the India's leading experts <br />
              Join the best live learning platform today
            </p>
            <b-button variant="outline-secondary" class="facebook-login-lg ">
              <font-awesome-icon :icon="['fab', 'facebook-square']" />
              <span>Signup with facebook</span>
            </b-button>
          </b-col>
          <b-col cols="12" md="6">
            <div class="signup-wrapper">
              <div class="heading squiggly-line-color line-center">
                Student Registration
              </div>
              <b-form class="row" data-vv-scope="register">
                <b-form-group
                  id="input-group-1"
                  label=""
                  label-for="input-1"
                  description=""
                  class="col-12"
                >
                  <b-form-input
                    id="input-1"
                    type="text"
                    required
                    placeholder="Enter your name*"
                    v-validate="'required|max:20|alpha_spaces'"
                    name="Name"
                    v-model.trim="firstName"
                    :class="{ 'is-invalid': errors.has('register.Name') }"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-1-live-feedback">
                    <small>{{ errors.first("register.Name") }}</small>
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  id="input-group-2"
                  label=""
                  label-for="input-2"
                  description=""
                  class="col-12"
                >
                  <b-form-input
                    id="input-2"
                    type="email"
                    v-validate="'required|email'"
                    placeholder="Enter email Id*"
                    name="email"
                    v-model="email"
                    :class="{ 'is-invalid': errors.has('register.email') }"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-1-live-feedback">
                    <small>{{ errors.first("register.email") }}</small>
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  id="input-group-3"
                  label=""
                  label-for="input-3"
                  description=""
                  class="col-6"
                >
                  <b-form-input
                    id="input-3"
                    type="text"
                    required
                    placeholder="Phone number*"
                    v-validate="'required|min:10|max:10|numeric'"
                    data-ismobileonly="false"
                    name="phonenumber"
                    v-model="phnNo"
                    :class="{
                      'is-invalid': errors.has('register.phonenumber')
                    }"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-1-live-feedback">
                    <small>{{ errors.first("register.phonenumber") }}</small>
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  id="input-group-4"
                  label=""
                  label-for="input-4"
                  description=""
                  class="col-6"
                >
                  <b-form-input
                    id="input-4"
                    type="text"
                    required
                    placeholder="Location*"
                    v-validate="'required|alpha|max:20|min:3'"
                    data-ismobileonly="false"
                    name="Location"
                    v-model="location"
                    :class="{
                      'is-invalid': errors.has('register.Location')
                    }"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-8-live-feedback">
                    <small>{{ errors.first("register.Location") }}</small>
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  id="input-group-5"
                  label="Enter password*"
                  label-for="input-5"
                  description=""
                  class="col-6"
                >
                  <b-form-input
                    id="input-5"
                    type="password"
                    required
                    placeholder="**********"
                    name="password"
                    v-model="password"
                    :class="{ 'is-invalid': errors.has('register.password') }"
                    v-validate="'required|min:8'"
                    ref="password"
                    autocomplete="off"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-1-live-feedback">
                    <small>{{ errors.first("register.password") }}</small>
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  id="input-group-6"
                  label="Re enter password*"
                  label-for="input-6"
                  description=""
                  class="col-6"
                >
                  <b-form-input
                    id="input-6"
                    type="password"
                    required
                    placeholder="**********"
                    name="Confirm Password"
                    v-model="confirmPassword"
                    :class="{
                      'is-invalid': errors.has('register.Confirm Password')
                    }"
                    v-validate="'required|confirmed:password'"
                    autocomplete="off"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-1-live-feedback">
                    <small>
                      {{ errors.first("register.Confirm Password") }}</small
                    >
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-button v-if="!showOtpField"
                  v-b-modal.registeration-success-modal
                  size="lg"
                  pill
                  variant="primary"
                  type="submit"
                  @click.prevent="action('register')"
                >
                  <span>Sign up for free</span>
                  <font-awesome-icon icon="arrow-right" size="xs" />
                </b-button>
              </b-form>
              <otp-form v-if="showOtpField" :phone_number="phnNo" @signUp="signUp"></otp-form>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </section>
</template>

<script>
import { authenticationApi } from "../../services/authenticationApi";
import { store } from "../../store/store";
import OtpForm from "../Templates/OtpForm";
export default {
    components: {OtpForm},
    name: "register_banner",
  data() {
    return {
      firstName: "",
      email: "",
      phnNo: "",
      password: "",
      confirmPassword: "",
      location: "",
      showRegisterError: false,
      role: "student",
        showOtpField:false
    };
  },
  methods: {
    action(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.showRegisterError = false;
          this.sendOTP();
        } else {
          this.showRegisterError = true;
        }
      });
    },
    signUp() {
      const userData = {
        name: this.firstName,
        email: this.email,
        mobile_number: this.phnNo,
        password: this.password,
        confirm_password: this.confirmPassword,
        location: this.location,
        role: this.role
      };
      this.showOtpField = false;
      authenticationApi
        .signUp(userData)
        .then(res => {
          this.$router.push({
            name: "userdashboard",
            path: "/student/dashboard",
            query: {
              role: this.role,
              isRegister: true
            }
          });
        })
        .catch(e => {
          this.$bvToast.toast(`Registration Failed ${e.body.message}`, {
            title: "Register",
            variant: "danger",
            autoHideDelay: 500,
            appendToast: true
          });
          //   console.error(e);
        });
      store.dispatch("user/setUserRole", this.role);
    },
      sendOTP(){
          let otpdata = {
              phone_number : this.phnNo,
          };
          this.showOtpField = true;
          authenticationApi.sendOTP(otpdata).then(res => {
              console.log("otp send successfully",res)
          })
      }
  }
};
</script>

<style></style>
